import type { IGridPayloadRequest } from '@/types/list'

const isValidDateString = (value: unknown): value is string => {
    if (typeof value !== 'string') {
        return false
    }

    const date = new Date(value)
    return !isNaN(date.getTime()) && value.split('T').length === 2
}

export const buildQueryForGrid = (data: IGridPayloadRequest) => {
    const { pageNumber, itemsPerPage, sort, filters } = data
    const filterKeys = Object.keys(filters)

    const queryObject: Record<string, string> = {
        page: String(pageNumber),
        itemsPerPage: String(itemsPerPage),
    }

    if (filterKeys.length) {
        filterKeys.forEach((filterKey) => {
            if (
                filters[filterKey] === null ||
                filters[filterKey] === undefined ||
                filters[filterKey] === ''
            ) {
                return
            }

            let value = filters[filterKey]

            if (isValidDateString(value)) {
                value = value.split('T')[0]!
            }

            queryObject[`filters[${filterKey}]`] = String(value)
        })
    }

    if (sort && sort.type !== null) {
        queryObject[`sorts[${sort.key}]`] = String(sort.type)
    }

    return new URLSearchParams(queryObject).toString()
}
